import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Veiculo } from "../../../../services/Veiculo";
import { IConsultaVeiculoChassiForm } from "../../../../types/veiculo";

export const useConsultarVeiculoPorChassi = () => {
  return useMutation({
    mutationFn: (data: IConsultaVeiculoChassiForm) =>
      Veiculo.postByChassi(data),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
